import type { GasUnit } from "./generated/GasUnit";
import { GAS_UNIT_CATALOG } from "./generated/unit-catalog";

/**
 * The natural gas units a reader can pick for gas rates and gas usage
 * (Preferences → Units). A display choice only: gas is stored in therms and
 * `$/therm`, and `lib/units.ts` converts at render time. Generated from the
 * Rust `GasUnit` and unit catalog (`pilot_domain::units`), so the factors and
 * labels here are the server's, not a hand copy.
 */
export type { GasUnit };

/** Every unit, in picker order. */
export const GAS_UNITS: readonly GasUnit[] = GAS_UNIT_CATALOG.map((u) => u.code);

/** How each unit is written beside a volume — `12.5 Mcf`, `1,200 therms`. */
export const GAS_UNIT_LABELS = Object.fromEntries(
  GAS_UNIT_CATALOG.map((u) => [u.code, u.usageLabel]),
) as Record<GasUnit, string>;

/** Therms in one of each unit: a Ccf is one; an Mcf, a Dth and an MMBtu are ten. */
export const THERMS_PER_GAS_UNIT = Object.fromEntries(
  GAS_UNIT_CATALOG.map((u) => [u.code, u.thermsPerUnit]),
) as Record<GasUnit, number>;
